import styles from "./NewPostIndicator.module.scss";

interface NewPostIndicatorProps {
  count: number;
  onClick: () => void;
  loading: boolean;
}

export default function NewPostIndicator({
  count,
  onClick,
  loading,
}: NewPostIndicatorProps) {
  if (count === 0) {
    return null;
  }

  const label = count === 1 ? "1 New Post" : `${count} New Posts`;

  return (
    <button
      className={styles.indicator}
      onClick={onClick}
      disabled={loading}
      aria-label={`Load ${label.toLowerCase()}`}
    >
      {loading ? "Loading…" : label}
    </button>
  );
}
